module.exports = __webpack_public_path__ + "img/schedule_b4.39ce55f5.png";